__turbopack_context__.v({
  "body": "BiomarkersScienceSection-module__-MXRWG__body",
  "card": "BiomarkersScienceSection-module__-MXRWG__card",
  "cta": "BiomarkersScienceSection-module__-MXRWG__cta",
  "outer": "BiomarkersScienceSection-module__-MXRWG__outer",
  "stage": "BiomarkersScienceSection-module__-MXRWG__stage",
  "textStack": "BiomarkersScienceSection-module__-MXRWG__textStack",
  "title": "BiomarkersScienceSection-module__-MXRWG__title",
});
